/**
 * The currency a fund's figures are in. Set by an admin on the fund — nothing
 * in a workbook or a statement says it reliably — and used only for display:
 * the portal formats an amount in its fund's currency, it never converts.
 */
export const FUND_CURRENCIES = ['ILS', 'USD', 'EUR', 'GBP'];
export const FUND_CURRENCY_LABELS_HE = {
    ILS: '₪ שקל',
    USD: '$ דולר',
    EUR: '€ אירו',
    GBP: '£ ליש"ט',
};
export const isFundCurrency = (s) => typeof s === 'string' && FUND_CURRENCIES.includes(s);
//# sourceMappingURL=currency.js.map